"use strict";

exports.__esModule = true;
exports.getPlantStateColors = getPlantStateColors;
/**
 * Get a dictionary of plant state ids to associated colors.
 */
function getPlantStateColors(theme) {
  return {
    producing: theme.ProducingStateColor,
    setup: theme.SetupStateColor,
    standby: theme.StandbyStateColor,
    "downtime.unplanned": theme.UnplannedDowntimeStateColor,
    "downtime.planned": theme.PlannedDowntimeStateColor,
    "data-unavailable": theme.DataUnavailableStateColor,
    shutdown: theme.ShutdownStateColor
  };
}